import {isEmpty} from "../../appHelper";

export interface Metrics {
    systemId: string;
    metricVersion: number;
    metricJson: string;
    requestTimestamp: string;
    result: string;
    downloadTimestamp: string;
    name: string;
}

export interface MetricListResponse {
    responseCode: string;
    timestamp: number;
    metricsList: Metrics[];
}

export interface MetricJsonGenResponse {
    p1Devices: any[];
    mpyRegisters: any[];
    modbusDevices: any[];
    metrics: any[];
    policy: any;
}

export interface MetricJsonGenApiResponse {
    responseCode: string;
    timestamp: number;
    metricJsonGenResponse: MetricJsonGenResponse;
}

export interface AddMetricsRequest {
    systemId: string;
    name: string;
    metricsJson: string;
}

export const initialAddMetricsRequest: AddMetricsRequest = {
    systemId: '',
    name: "",
    metricsJson: "",
};

export const isAddMetricsRequestValid = (request: AddMetricsRequest) => {
    return (
        !isEmpty(request.systemId) &&
        !isEmpty(request.name) &&
        !isEmpty(request.metricsJson)
    );
};
